import { useState, useCallback } from 'react';

const STORAGE_KEY = 'farmdirectly_recently_viewed';
const MAX_ITEMS = 12;

const useRecentlyViewed = () => {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch {
      return [];
    }
  });

  const addProduct = useCallback((product) => {
    if (!product || !product._id) return;

    const primaryImage = product.images?.find(i => i.isPrimary) || product.images?.[0];

    const entry = {
      _id: product._id,
      name: product.name,
      slug: product.slug,
      price: product.price,
      image: primaryImage?.url || '',
      category: product.category,
      viewedAt: Date.now(),
    };

    setItems((prev) => {
      const filtered = prev.filter((p) => p._id !== product._id);
      const updated = [entry, ...filtered].slice(0, MAX_ITEMS);
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(updated)); } catch {}
      return updated;
    });
  }, []);

  const clearAll = useCallback(() => {
    setItems([]);
    try { localStorage.removeItem(STORAGE_KEY); } catch {}
  }, []);

  return { recentlyViewed: items, addProduct, clearAll };
};

export default useRecentlyViewed;
